import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { ThemeDefault } from "./ThemeDefault";
import { deepExtend } from "../../../Utils/Utils";
export var Theme = /*#__PURE__*/function () {
  function Theme() {
    _classCallCheck(this, Theme);
    this.name = "";
    this.default = new ThemeDefault();
  }
  _createClass(Theme, [{
    key: "load",
    value: function load(data) {
      if (data === undefined) {
        return;
      }
      if (data.name !== undefined) {
        this.name = data.name;
      }
      this.default.load(data.default);
      if (data.options !== undefined) {
        this.options = deepExtend({}, data.options);
      }
    }
  }]);
  return Theme;
}();